module.exports = __webpack_public_path__ + "img/icono_G5.6fceac43.svg";